import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    login: {
      title: 'Nazwa użytkownika',
      format: 'email',
      type: 'string',
      fieldRequired: true,
      validationMessages: {
        format: 'Błąd: Nieprawidłowy format, nazwa użytkownika musi być wprowadzona w formacie nazwa@domena.'
      }
    },
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
